import Annotation from "./annotation";
import { setLineStyle } from "../canvasUtils";

export default class ImageBrowserViewFinder extends Annotation {
  constructor() {
    super();
    this.x = 0;
    this.y = 0;
    this.width = 0;
    this.height = 0;
    this.lineWidth = 3;
    this.color = "red";
  }

  draw(ctx) {
    if (!this.width) return;
    setLineStyle(ctx, this);

    ctx.beginPath();
    ctx.strokeRect(this.x, this.y, this.width, this.height);
    ctx.closePath();
  }

  updateViewFinder(transform, fittedImgSize, mainViewCanvasSize) {
    if (!mainViewCanvasSize || !fittedImgSize || !transform) return;

    const scaledZoom = transform.zoom / transform.fitZoom;
    let offset = 1100 / window.innerHeight;

    let canvasAspect = mainViewCanvasSize.w / mainViewCanvasSize.h;
    let imgAspect = fittedImgSize.w / fittedImgSize.h;

    if (canvasAspect > imgAspect) {
      let diff = canvasAspect / imgAspect;
      this.width = diff * (fittedImgSize.w / scaledZoom) - offset;
      this.height = (fittedImgSize.h / scaledZoom) - offset;
  
      this.x = fittedImgSize.w * (transform.centerX - diff / (2 * scaledZoom));
      this.y = fittedImgSize.h * (transform.centerY - 1 / (2 * scaledZoom));
    } else {
      let diff = imgAspect / canvasAspect;
      this.width = (fittedImgSize.w / scaledZoom) - offset;
      this.height = diff * (fittedImgSize.h / scaledZoom) - offset;
  
      this.x = fittedImgSize.w * (transform.centerX - 1 / (2 * scaledZoom));
      this.y = fittedImgSize.h * (transform.centerY - diff / (2 * scaledZoom));
    }

    // todo - uncomment the following restrictions if the client wants the view box to stay inside the image
    // if (this.width > fittedImgSize.w)
    //   this.width = fittedImgSize.w;
    // if (this.height > fittedImgSize.h)
    //   this.height = fittedImgSize.h;
    
    // if (this.x < 0)
    //   this.x = 0;
    // if (this.x + this.width > fittedImgSize.w)
    //   this.x = fittedImgSize.w - this.width;
    // if (this.y < 0)
    //   this.y = 0;
    // if (this.y + this.height > fittedImgSize.h)
    //   this.y = fittedImgSize.h - this.height;

    this.signalReady();
  }
}